import { FontFamily } from '@euler/components/typography';
import { versionText } from '@euler/components/VersionText';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { nativeApplicationVersion } from 'expo-application';
import { memo } from 'react';
import { StyleProp, Text, View, ViewStyle } from 'react-native';

export const VersionInfo = memo(
  ({ style }: { style?: StyleProp<ViewStyle> }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        css={`
          align-items: center;
        `}
        style={style}
      >
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Light};
            font-size: ${rpx(10)}px;
            color: #666;
            margin-bottom: ${rpx(4)}px;
          `}
        >
          Powered by zhichetech.com, © 2019-2023.
        </Text>
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Light};
            font-size: ${rpx(10)}px;
            color: #777;
          `}
        >
          {nativeApplicationVersion} ({versionText(8)})
        </Text>
      </View>
    );
  },
);
